import Breadcrumb from '../../../../../pages/vip/features/breadcrumb';

export default Breadcrumb;
